import React from "react";

/** Mobile-first app shell so it looks like a phone app even on desktop */
export default function AppShell({ children, showShell = true }) {
    if (!showShell) return children;
    return (
        <div className="min-h-screen bg-black flex justify-center items-stretch grain">
            <div className="w-full max-w-md min-h-screen bg-ink-950 relative overflow-hidden border-x border-white/5">
                {children}
            </div>
        </div>
    );
}
